import Menu from 'antd/lib/menu'

import 'antd/lib/menu/style'

export * from 'antd/lib/menu'

export default Menu
